exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  align-items: center;\n  background-color: #f6f6f6;\n  display: flex;\n  padding: 8px;\n}\n.footer .analyze-btn {\n  margin-right: 8px;\n}\n.footer .analyze-description {\n  font-weight: 600;\n}\n", ""]);

// exports
